module.exports = __webpack_public_path__ + "img/favicon.5064b275.svg";